"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ts_validators_1 = require("ts-validators");
const General_1 = require("../../types/General");
const unknownRemoveAllRecursiveReferences_1 = __importDefault(require("../../shared/unknownRemoveAllRecursiveReferences"));
const callableUnknownToJsonString = ({ processor, entryVars: { [General_1.DEFINITION_PROP_NAMES.VALUE]: value, [General_1.DEFINITION_PROP_NAMES.ERROR_VALUE]: errorValue, [General_1.DEFINITION_PROP_NAMES.ALLOW_RECURSIVE_OBJECTS]: allowRecursiveObjects, }, }) => {
    if (allowRecursiveObjects !== undefined && !(0, ts_validators_1.valueIsBoolean)(allowRecursiveObjects)) {
        if (processor.root.isInDevelopment) {
            processor.root.alert('Error unknownToJsonString', 'The allowRecursiveObjects property must be a boolean');
        }
        return undefined;
    }
    let valueToSerialize = value;
    if (allowRecursiveObjects) {
        valueToSerialize = (0, unknownRemoveAllRecursiveReferences_1.default)(valueToSerialize);
    }
    try {
        const serializedValue = JSON.stringify(valueToSerialize);
        return serializedValue;
    }
    catch (_a) {
        if (errorValue) {
            return errorValue;
        }
        if (processor.root.isInDevelopment) {
            processor.root.alert('Error unknownToJsonString', 'Value could not be serialized to JSON');
        }
        return undefined;
    }
};
exports.default = callableUnknownToJsonString;
